import type { FieldRootProps } from '@base-ui/react';

import { Field as BaseField } from '@base-ui/react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { useMemo } from 'react';

import { clsxs } from '~/styles/utils';
import { mergeRefs } from '~/utils/mergeRefs';

import { verticalFieldAnimation } from './Field.utils';
import { fieldRootStyle, growStyle } from './FieldRoot.css';

type Props = FieldRootProps & {
  grow?: boolean;
};

export const FieldRoot = ({ grow = false, ...delegated }: Props) => {
  const [ref] = useAutoAnimate(verticalFieldAnimation);

  const mergedRef = useMemo(() => mergeRefs(ref, delegated.ref), [ref, delegated.ref]);

  return <BaseField.Root {...delegated} className={clsxs(fieldRootStyle, grow && growStyle, delegated.className)} ref={mergedRef} />;
};
